//Constants
import * as ACTIONS from './actionTypes';

//Types
import { ActionGetUrlSetupAPISuccess } from './actions';
export interface UrlSetupState {
    url?: string
}

const defaultState: UrlSetupState = {
    url: undefined
};


type UrlSetupAction = ActionGetUrlSetupAPISuccess;

function urlSetupReducer(state: UrlSetupState = defaultState, action: UrlSetupAction): UrlSetupState {
    switch (action.type) {
        case ACTIONS.GET_URLSETUP_API_SUCCESS:
            {
                const { url } = action as ActionGetUrlSetupAPISuccess;
                return {
                    ...state,
                    url: url
                }
            }
    }
    return {
        ...state
    }
}

export default urlSetupReducer;